import Button from "@mui/material/Button";
import qrimg from "../../assets/qr-2-remove.png";
import { useSnackbar } from "../../context/SnackBarContext";
import HorizontalLinearStepper from "../../component/HorizontalLinearStepper";
import { useState } from "react";
import ProfileForm from "./ProfileForm";
import { useQrAuth } from "../../context/QrAuth";
import axios from "axios";
import { apiUrl } from "../../utils/utils";
import { Link, useNavigate } from "react-router-dom";

export default function CreateAccountForm() {
    const [activeStep, setActiveStep] = useState(0);
    const navigate = useNavigate()
    const [formData, setFormData] = useState({
        username: "",
        password: "",
        confirmPassword: "",
        name: "",
        title: "",
        company: "",
        telephone: "",
        email: "",
        address: "",
        linkedin: "",
        website: "",
        image: null,
    });
    const [error, setError] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    const { showSuccess, showError } = useSnackbar();
    const { setUser: setLoggedUser, setIsAuthenticated } = useQrAuth();

    // const handleNext = () => setActiveStep((prev) => prev + 1);
    const handleBack = () => setActiveStep((prev) => prev - 1);
    const handleSkip = () => setActiveStep((prev) => prev + 1);
    const handleReset = () => setActiveStep(0);

    // const handleSubmit = () => {
    //     if (formData.password !== formData.confirmPassword) {
    //         showError("Passwords do not match!");
    //         return;
    //     }

    //     if (!formData.name.trim()) {
    //         return showError("Name is Required");
    //     }

    //     setIsLoading(true);
    //     const payload = new FormData();
    //     Object.keys(formData).forEach((key) => {
    //         if (formData[key] !== null) payload.append(key, formData[key]);
    //     });

    //     axios.post(`${apiUrl}qr/auth/register`, payload, {
    //         headers: { "Content-Type": "multipart/form-data" },
    //     })
    //         .then((res) => {
    //             const data = res.data.data;
    //             setLoggedUser(data);
    //             localStorage.setItem("token", JSON.stringify(res.data.jwt));
    //             setIsAuthenticated(true);
    //             showSuccess("Account Created Successfully!");
    //             navigate("/contact-card/login")
    //         })
    //         .catch((err) => {
    //             showError(err.response?.data?.message || "Internal Server Error");
    //         })
    //         .finally(() => {
    //             setIsLoading(false);
    //         });
    // };
    const handleNext = () => {
        if (activeStep == 0) {
            if (!formData.email.trim()) return showError("Email is required");
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(formData.email)) return showError("Invalid email format");

            if (!formData.password.trim()) return showError("Password is required");
            if (formData.password.length < 6) return showError("Password must be at least 6 characters");
            if (formData.password !== formData.confirmPassword) return showError("Passwords do not match!");
        }
        else if (activeStep == 1) {
            if (!formData.name.trim()) return showError("Name is required");
            if (!formData.title.trim()) return showError("Designation is required");
            if (!formData.company.trim()) return showError("Company is required");
            if (!formData.telephone.trim()) return showError("Phone number is required");

            const phoneRegex = /^[0-9]{10,12}$/;
            if (!phoneRegex.test(formData.telephone)) return showError("Invalid phone number (digits only, 10–12)");

            if (!formData.address.trim()) return showError("Address is required");
            if (!formData.linkedin.trim()) return showError("LinkedIn is required");
            if (!formData.website.trim()) return showError("Website is required");
        }
        setActiveStep((prev) => prev + 1)
    }

    const handleSubmit = () => {
        setIsLoading(true);
        const payload = new FormData();
        Object.keys(formData).forEach((key) => {
            if (formData[key] !== null) payload.append(key, formData[key]);
        });

        axios.post(`${apiUrl}qr/auth/register`, payload, {
            headers: { "Content-Type": "multipart/form-data" },
        })
            .then((res) => {
                const data = res.data.data;
                setLoggedUser(data);
                localStorage.setItem("token", JSON.stringify(res.data.jwt));
                setIsAuthenticated(true);
                showSuccess("Account Created Successfully!");
                navigate("/contact-card/login");
            })
            .catch((err) => {
                showError(err.response?.data?.message || "Internal Server Error");
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    return (
        <div className="grid md:grid-cols-2 min-h-screen items-start justify-center bg-white">
            <div className="hidden md:flex flex-col items-center h-full bg-gradient-to-br from-[#bf98ce] to-[rgb(143,119,198)]">
                <h2 className="text-[40px] font-bold text-white mb-4 mt-24">Get your contact QR</h2>
                <img src={qrimg} alt="Create Account" className="object-contain w-[600px]" />
            </div>

            <div className="px-20 bg-white pb-10">
                <h2 className="text-[30px] font-bold text-[rgb(143,119,198)] mb-10 mt-24">Sign up</h2>

                <HorizontalLinearStepper
                    activeStep={activeStep}
                    handleNext={handleNext}
                    handleBack={handleBack}
                    handleSkip={handleSkip}
                    handleReset={handleReset}
                />

                {activeStep === 3 ? (
                    <div className="mt-6">
                        <div className="mb-4">✅ All steps completed!</div>
                        <Button
                            onClick={handleSubmit}
                            variant="contained"
                            className="!bg-[#8f77c6] !text-white"
                            disabled={isLoading}
                        >
                            {isLoading ? "Submitting..." : "Submit"}
                        </Button>
                        <Button onClick={handleReset} className="ml-4">
                            Reset
                        </Button>
                    </div>
                ) : (
                    <div className="mt-6">
                        <ProfileForm
                            step={activeStep}
                            formData={formData}
                            setFormData={setFormData}
                            error={error}
                            setError={setError}
                        />

                        <div className="flex justify-between mt-6">
                            {activeStep !== 0 && (
                                <Button
                                    onClick={handleBack}
                                    variant="outlined"
                                    sx={{
                                        color: 'gray',
                                        borderColor: 'gray',
                                        '&:hover': {
                                            borderColor: 'gray',
                                            backgroundColor: 'transparent',
                                        },
                                    }}
                                >
                                    Back
                                </Button>
                            )}
                            <Button
                                onClick={activeStep === 2 ? handleSubmit : handleNext}
                                className="!bg-[#8f77c6] !text-white"
                                disabled={isLoading}
                            >
                                {activeStep == 2 ? (isLoading ? "Submitting..." : "Submit") : "Next"}
                            </Button>
                        </div>
                    </div>
                )}
                <Link
                    to="/contact-card/login"
                    className="block text-sm font-semibold mb-1 text-center mt-10"
                >
                    Have an account?{" "}
                    <span className="text-[#8f77c6]">Login</span>
                </Link>
            </div>


        </div>
    );
}
